"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractService2 = _interopRequireDefault(require("../../AbstractService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * This class handles authentication token.
 */
var OneWebAuthService = /*#__PURE__*/function (_AbstractService) {
  _inherits(OneWebAuthService, _AbstractService);

  var _super = _createSuper(OneWebAuthService);

  function OneWebAuthService() {
    var _this;

    _classCallCheck(this, OneWebAuthService);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "connectionTimeout", 15000);

    return _this;
  }

  _createClass(OneWebAuthService, [{
    key: "getToken",

    /**
     * Returns token.
     *
     * @param {object} options Configuration.
     * @param {object} options.endpoints API endpoints.
     * @param {string} options.clientId API credentials.
     * @param {string} options.clientSecret API credentials.
     * @param {string} options.apiLocalePath API locale path. Example: "gb/en".
     * @returns {Promise} Promise object.
     */
    value: function getToken(options) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var iframe = document.createElement('iframe');
        var countryAndLanguage = options.apiLocalePath.split('/');
        var timeout = setTimeout(function () {
          return reject(new Error('Failed to retrieve token from iframe. Request timed out. Connection problems?'));
        }, _this2.connectionTimeout);

        var onTokens = function onTokens(error, tokens) {
          window.removeEventListener('message', onTokens);
          document.body.removeChild(iframe);
          clearTimeout(timeout);

          if (error) {
            reject(new Error('Failed to retrieve token from iframe. Error: ' + error));
          } else {
            var token = tokens.auth ? tokens.auth : tokens.guest;
            resolve({
              token: token,
              isGuest: !tokens.auth
            });
          }
        };

        iframe.addEventListener('load', function () {
          if (iframe.contentWindow) {
            var ikea = iframe.contentWindow.ikea;

            if (ikea && ikea.authentication && ikea.authentication.getTokens) {
              ikea.authentication.getTokens(onTokens);
            } else {
              reject(new Error('Failed to retrieve token from iframe. "ikea.authentication.getTokens()" not defined.'));
            }
          } else {
            reject(new Error('Failed to retrieve token from iframe. Missing access to iframe.contentWindow.'));
          }
        });
        iframe.src = options.endpoints.oneWebAuthenticationToken.replace('{country}', countryAndLanguage[0]).replace('{language}', countryAndLanguage[1]);
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
      });
    }
    /**
     * Returns the name used by ServiceFactory.
     *
     * @override
     * @returns {string} Factory name.
     */

  }], [{
    key: "factoryName",
    get: function get() {
      return 'onewebauth';
    }
  }]);

  return OneWebAuthService;
}(_AbstractService2.default);

exports.default = OneWebAuthService;